
import { defineComponent } from "vue";

export default defineComponent({
  name: "NoRecords",

  props: {
    message: {
      type: String,
      default: "",
    },
  },
});
